import React from "react"
import LiteYouTubeEmbed from 'react-lite-youtube-embed'
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiText
} from '@elastic/eui'


export default function YoutubeVideoCardAdhoc() {
  
  return (
    <React.Fragment>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                <LiteYouTubeEmbed 
                    id="ZyEI9TZsdl0"
                    title="WLAN Direktverbindung per AdHoc einrichten | Anleitung für Ihre INSTAR 2K+ Überwachungskamera"
                    adNetwork={true}
                    poster="maxresdefault" //hqdefault
                    noCookie={true}
                />
              }
              title="AdHoc WLAN Accesspoint"
              footer={
                <EuiText>
                  <p>WLAN Direktverbindung per AdHoc einrichten | Anleitung für Ihre INSTAR 2K+ Überwachungskamera</p>
                </EuiText>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
    </React.Fragment>
  );
}
